import React from 'react'

interface IProps {
    image?: string,
    imageName?: string,
    content?: any,
}

class Card extends React.Component<IProps> {
    render() {
        return (
            <div className="card">
                {this.props.image && 
                    <div className="image">
                        <img src={this.props.image} alt={this.props.imageName} className="mx-auto d-block" />
                    </div>
                }
                {this.props.content && 
                    <div className="content">{this.props.content}</div>
                }
            </div>
        )
    }
}

export default Card